import {
  LoadOrganizationConfig,
  SetOrganizationConfig,
  LoadOrganizationProfile,
  SetOrganizationProfile,
  SetUserName,
  SetUserId,
  SetUserRoles,
  SetUserOrganization,
  SetUserApiError,
  RemoveUserApiError,
  SetOrganizationAccesses,
} from './user.actions';
import { UserApiError } from './user.errors';
import {
  Organization,
  OrganizationAccesses,
  OrganizationConfig,
} from 'src/app/admin/models/organization.model';
import { createReducer, on } from '@ngrx/store';

export interface UserState {
  roles: string[];
  familyName: string;
  givenName: string;
  id: string;
  organizationId: number;
  organizationName: string;
  organizationDisplayName: string;
  organizationType: string;
  organizationRoles: string[];
  organizationProfile: Organization;
  organizationConfig: OrganizationConfig;
  organizationAccesses?: OrganizationAccesses;
  apiError: UserApiError;
}

export type UserNames = Pick<UserState, 'familyName' | 'givenName'>;

export const initialUserState: UserState = {
  roles: [],
  familyName: null,
  givenName: null,
  id: null,
  organizationId: null,
  organizationName: null,
  organizationDisplayName: null,
  organizationType: null,
  organizationRoles: [],
  organizationProfile: null,
  organizationConfig: null,
  apiError: null,
  organizationAccesses: null,
};

export const userReducer = createReducer(
  initialUserState,
  on(LoadOrganizationConfig, (state) => ({ ...state, organizationConfig: null, apiError: null })),
  on(SetOrganizationAccesses, (state, { organizationAccesses }) => ({
    ...state,
    organizationAccesses,
  })),
  on(SetOrganizationConfig, (state, { organizationConfig }) => ({ ...state, organizationConfig })),
  on(LoadOrganizationProfile, (state) => ({ ...state, organizationProfile: null, apiError: null })),
  on(SetOrganizationProfile, (state, { organizationProfile }) => ({
    ...state,
    apiError: null,
    organizationProfile: { ...state.organizationProfile, ...organizationProfile },
  })),
  on(SetUserName, (state, { familyName, givenName }) => ({
    ...state,
    familyName,
    givenName,
  })),
  on(SetUserId, (state, { id }) => ({ ...state, id })),
  on(SetUserRoles, (state, { roles }) => ({ ...state, roles })),
  on(SetUserOrganization, (state, { name, displayName, id, orgType, orgRoles }) => ({
    ...state,
    organizationName: name,
    organizationDisplayName: displayName,
    organizationId: id,
    organizationType: orgType,
    organizationRoles: orgRoles,
  })),
  on(SetUserApiError, (state, { error }) => ({ ...state, apiError: error })),
  on(RemoveUserApiError, (state) => ({ ...state, apiError: null })),
);
